import script from "./HackingParaIniciantes.vue?vue&type=script&setup=true&lang=ts"
export * from "./HackingParaIniciantes.vue?vue&type=script&setup=true&lang=ts"

import "./HackingParaIniciantes.vue?vue&type=style&index=0&id=194ecd61&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4241219202/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-194ecd61"]])

export default __exports__